import {SvgIcon} from '@mui/material';
import { ReactComponent as FileAddOutlinedSvg } from "./fileAddOutlinedIcon.svg";

export const FileAddOutlined = () => {
    return <SvgIcon component={FileAddOutlinedSvg} />
}